var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style),attrs:{"id":"layout-main"}},[_c('layout-tabs'),_c('div',{attrs:{"id":"main-wrapper"}},[_c('div',{attrs:{"id":"main-container"}},[_c('layout-breadcrumb'),_c('layout-main-content')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }